import { TypographyProps } from '@mui/material';
import { Typography } from 'shared/mui/Typography';

export type TypographySize = 'large' | 'medium' | 'small' | 'smallBold' | 'xsmall' | 'xsmallBold';

export type TypographyTitleProps = TypographyProps & {
  size?: TypographySize;
};

const sizeConfig: Record<TypographySize, TypographyProps> = {
  large: {
    variant: 'h4',
    fontSize: '28px',
  },
  medium: {
    variant: 'h5',
    fontSize: '24px',
  },
  small: {
    variant: 'h6',
    fontSize: '20px',
  },
  smallBold: {
    variant: 'h6',
    fontSize: '20px',
    fontWeight: 500,
  },
  xsmall: {
    variant: 'h6',
    fontSize: '16px',
  },
  xsmallBold: {
    variant: 'h6',
    fontSize: '16px',
    fontWeight: 500,
  },
};

export function TypographyTitle({
  children,
  size = 'medium',
  ...restProps
}: TypographyTitleProps): JSX.Element {
  return (
    <Typography {...restProps} {...sizeConfig[size]}>
      {children}
    </Typography>
  );
}
